module.exports = __webpack_public_path__ + "way1-4912b3a12461114784acbbd58d8b0578.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/way1.png
// module id = SfFG
// module chunks = client